import api from "../../../BrandOnBoarding/api";

/**
 * POST /getMonitoringHomeData — one call returns EVERYTHING for this
 * customer: every brand + product, every combination each has ever run,
 * and the full run history per combination. There is no follow-up call as
 * the user changes dropdowns — all filtering happens client-side against
 * this one response (see MONITORING_HOMEPAGE_RESPONSE_FIX_SPEC.md).
 *
 * `userId` is required for the `report[]` section to be populated — omit
 * it and the call still succeeds but every report comes back null.
 */
export async function fetchMonitoringHomeData({ customerId, userId }) {
  const response = await api.post("/getMonitoringHomeData", { customerId, userId });
  return response?.data;
}

function toArray(v) {
  if (v == null || v === "") return [];
  return Array.isArray(v) ? v : [v];
}

function reportTypeLabel(row, sel) {
  const kind = String(sel.reportKind || row.type || "").toLowerCase();
  if (sel.reportType === "flash") return "Flash Change Report";
  if (kind.includes("change")) return "Change Report";
  return "Baseline Report";
}

/**
 * Full monitoring report history for this user — same endpoint the
 * Monitoring dashboard's "HTML Reporting" tab uses
 * (Dashboard/HTMLReporting/useMonitoringHTMLReportHistory.js). Returns
 * EVERY brand's reports for the user (e.g. Tesla + Ford together), newest
 * first, each carrying the combination it was launched for.
 */
export async function fetchMonitoringReportHistory({ userId }) {
  const response = await api.get("/llm-reporting/html-history", { params: { userId, types: "brand_monitoring_html" } });
  const rows = Array.isArray(response?.data) ? response.data : [];
  return rows
    .filter((row) => row.status !== "cancelled")
    .map((row) => {
      const sel = row.selections || {};
      const summary = row.input_summary || {};
      const brands = toArray(sel.brandNames);
      return {
        jobId: row.id,
        status: row.status,
        type: reportTypeLabel(row, sel),
        brand: brands.length ? brands.join(", ") : summary.brand || "",
        category: sel.category || "",
        llms: toArray(sel.llms),
        markets: toArray(sel.markets),
        persona: toArray(sel.persona),
        date: row.start_date || row.startDate,
      };
    })
    .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
}
